import { render, staticRenderFns } from "./Translate.vue?vue&type=template&id=da47dd32&scoped=true"
import script from "./Translate.vue?vue&type=script&lang=js"
export * from "./Translate.vue?vue&type=script&lang=js"
import style0 from "./Translate.vue?vue&type=style&index=0&id=da47dd32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da47dd32",
  null
  
)

export default component.exports